<template>
    <button v-show="showButton" @click="scrollToTop" class="z-40 rotate-180 bg-main-color hover:bg-accent-color ease-linear transition-all duration-150 flex items-center justify-center rounded-full w-10 h-10 pt-2 fixed bottom-20 right-[5%] max-lg:right-4 max-lg:w-9 max-lg:h-9 max-lg:pt-0">
        <IconArrowDown class="animate-bounce max-lg:h-4 max-lg:w-4 max-lg:animate-none"></IconArrowDown>
    </button>
</template>

<script setup>
import { ref, onUnmounted } from 'vue';
import IconArrowDown from '@icons/IconArrowDown.vue';
const showButton = ref(false)
    window.onscroll = () => isDown()
    const scrollToTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    const isDown = ()=> {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100){
            showButton.value = true
        }
        else{
            showButton.value = false
        }
    }
    onUnmounted(()=>{
        window.onscroll = null
    })
</script>